import React, { useMemo, useState } from 'react';

const allScopes = [
  'customers.read',
  'tickets.read',
  'tickets.write',
  'billing.read',
  'billing.write',
  'notifications.read',
  'monitoring.read',
  'provisioning.write',
  'webhooks.manage',
];

const CreateApiClientModal = ({ open, onClose, onSubmit, loading, createdApiKey }) => {
  const [name, setName] = useState('');
  const [selectedScopes, setSelectedScopes] = useState(['customers.read']);

  const canSubmit = useMemo(() => name.trim().length >= 2 && selectedScopes.length > 0, [name, selectedScopes]);

  if (!open) return null;

  const toggleScope = (scope) => {
    setSelectedScopes((prev) => (prev.includes(scope) ? prev.filter((item) => item !== scope) : [...prev, scope]));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canSubmit || loading) return;
    onSubmit({ name: name.trim(), scopes: selectedScopes });
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-xl rounded-xl border border-slate-700 bg-slate-950 p-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-100">Buat API Client</h3>
          <button type="button" onClick={onClose} className="text-xs text-slate-400 hover:text-slate-200">Tutup</button>
        </div>
        {createdApiKey ? (
          <div className="mb-3 rounded border border-amber-500/40 bg-amber-500/10 p-3 text-xs text-amber-200">
            API Key (tampilkan sekali):
            <div className="mt-1 break-all rounded bg-slate-900 p-2 font-mono text-[11px] text-amber-100">{createdApiKey}</div>
          </div>
        ) : null}
        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block text-xs text-slate-300">
            Nama Client
            <input value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-900 px-2 py-2 text-sm text-slate-100" placeholder="Contoh: Partner CRM" />
          </label>
          <div>
            <p className="mb-1 text-xs text-slate-300">Scope Akses</p>
            <div className="grid gap-2 sm:grid-cols-2">
              {allScopes.map((scope) => (
                <label key={scope} className="flex items-center gap-2 rounded border border-slate-700 bg-slate-900 px-2 py-1.5 text-xs text-slate-200">
                  <input type="checkbox" checked={selectedScopes.includes(scope)} onChange={() => toggleScope(scope)} />
                  {scope}
                </label>
              ))}
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="rounded border border-slate-700 px-3 py-2 text-xs text-slate-300">Batal</button>
            <button type="submit" disabled={!canSubmit || loading} className="rounded border border-cyan-400/45 bg-cyan-500/15 px-3 py-2 text-xs font-semibold text-cyan-200 disabled:opacity-50">
              {loading ? 'Menyimpan...' : 'Buat Client'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateApiClientModal;
